import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core'
import { DatadogConfiguration, DatadogService } from './datadog.service'
import { HTTP_INTERCEPTORS } from '@angular/common/http'

@NgModule()
export class MonitoringModule {
  public static forRoot(
    config: DatadogConfiguration
  ): ModuleWithProviders<MonitoringModule> {
    return {
      ngModule: MonitoringModule,
      providers: [
        {
          provide: DatadogService,
          useValue: new DatadogService(config),
        },
        {
          provide: ErrorHandler,
          useExisting: DatadogService,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useExisting: DatadogService,
          multi: true,
        },
      ],
    }
  }
}
